module.exports = __webpack_public_path__ + "img/norway-ischemic-heart-disease-female.3f40da5a.png";